import { useMutation } from '@tanstack/react-query';
import { processCodeRedirectCallback } from '../lib/oauth4webapi/processCodeRedirectCallback';
export const useProcessCodeRedirectCallbackMutation = (options) => {
    return useMutation({ mutationFn: processCodeRedirectCallback, ...options });
};
